export enum SurveyTag {
  MEDICATION_HISTORY = "medication-history",
  DIAGNOSIS = "diagnosis",
  PRESCRIBER_INFORMATION = "prescriber-information",
  LABORATORY_RESULTS = "laboratory-results",
  GENETIC_TESTING = "genetic-testing",
  DISEASE_ONSET_DIAGNOSIS_TIMELINE = "disease-onset-diagnosis-timeline",
  SKELETAL_MANIFESTATIONS = "skeletal-manifestations",
  NON_SKELETAL_SYSTEMIC_MANIFESTATIONS = "non-skeletal-systemic-manifestations",
  DISEASE_PROGRESSION = "disease-progression",
}

export const AVAILABLE_SURVEY_TAGS = [
  SurveyTag.MEDICATION_HISTORY,
  SurveyTag.DIAGNOSIS,
  SurveyTag.PRESCRIBER_INFORMATION,
  SurveyTag.LABORATORY_RESULTS,
  SurveyTag.GENETIC_TESTING,
  SurveyTag.DISEASE_ONSET_DIAGNOSIS_TIMELINE,
  SurveyTag.SKELETAL_MANIFESTATIONS,
  SurveyTag.NON_SKELETAL_SYSTEMIC_MANIFESTATIONS,
  SurveyTag.DISEASE_PROGRESSION,
];
